// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input[disabled][data-v-3f5dbc1c], .input[data-v-3f5dbc1c]:disabled, .input.is-disabled[data-v-3f5dbc1c] {\n  box-shadow: none;\n}", ""]);
// Exports
module.exports = exports;
